"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogEventLevelSeverity = exports.LogEventLevel = exports.LogEventSource = void 0;
const baseEvent_1 = require("./baseEvent");
const uuid_1 = require("uuid");
const zod_extensions_1 = require("@reachmedianetwork/zod-extensions");
/**
 * Log record source.
 *     - player: record was emitted by a media player device
 *     - user: record was emitted by user interaction in CMS (or other app)
 *     - system: record was generated by a REACH system component (e.g. server)
 */
var LogEventSource;
(function (LogEventSource) {
    LogEventSource["Player"] = "player";
    LogEventSource["User"] = "user";
    LogEventSource["System"] = "system";
})(LogEventSource = exports.LogEventSource || (exports.LogEventSource = {}));
var LogEventLevel;
(function (LogEventLevel) {
    LogEventLevel["debug"] = "debug";
    LogEventLevel["info"] = "info";
    LogEventLevel["notice"] = "notice";
    LogEventLevel["warning"] = "warning";
    LogEventLevel["error"] = "error";
    LogEventLevel["critical"] = "critical";
})(LogEventLevel = exports.LogEventLevel || (exports.LogEventLevel = {}));
exports.LogEventLevelSeverity = {
    debug: 10,
    info: 20,
    notice: 30,
    warning: 40,
    error: 50,
    critical: 60,
};
const LogEventSchema = zod_extensions_1.z.object({
    type: zod_extensions_1.z.literal('log'),
    source: zod_extensions_1.z.nativeEnum(LogEventSource),
    sourceId: zod_extensions_1.z.string(),
    level: zod_extensions_1.z.nativeEnum(LogEventLevel),
    category: zod_extensions_1.z.string(),
    subcategory: zod_extensions_1.z.string(),
    code: zod_extensions_1.z.string(),
    data: zod_extensions_1.z.record(zod_extensions_1.z.unknown()).optional(),
    id: zod_extensions_1.z.string(),
    time: zod_extensions_1.z.unknown().marshalTo('integer'),
    eid: zod_extensions_1.z.string().optional(),
});
class LogEvent extends baseEvent_1.default {
    constructor() {
        super(...arguments);
        this.type = 'log';
    }
    static create(source, sourceId, level, category, subcategory, code, data, eid) {
        const event = new LogEvent(uuid_1.v4(), Date.now(), eid);
        event._source = source;
        event._sourceId = sourceId;
        event._level = level;
        event._category = category;
        event._subcategory = subcategory;
        event._code = code;
        event._data = data;
        return event;
    }
    /**
     * The source actor type for the log event (e.g. player or user or system).
     */
    get source() {
        return this._source;
    }
    /**
     * The source actor id for the log event (e.g. username for user source).
     */
    get sourceId() {
        return this._sourceId;
    }
    /**
     * The log event level.
     */
    get level() {
        return this._level;
    }
    /**
     * The log category. Usually the software product emitting the log.
     */
    get category() {
        return this._category;
    }
    /**
     * The log subcategory. Usually the software component within the product
     * emitting the log (e.g. WeatherWidget).
     */
    get subcategory() {
        return this._subcategory;
    }
    /**
     * The application-specific log code (e.g. FRAME_CRASH).
     */
    get code() {
        return this._code;
    }
    /**
     * Arbitrary data payload. Usually specific to a log code.
     */
    get data() {
        return this._data;
    }
    getLogLevelSeverity() {
        return exports.LogEventLevelSeverity[this._level];
    }
    parse(record) {
        const parsedRecord = LogEventSchema.parse(record);
        const event = new LogEvent(parsedRecord.id, parsedRecord.time, parsedRecord.eid);
        event._source = parsedRecord.source;
        event._sourceId = parsedRecord.sourceId;
        event._level = parsedRecord.level;
        event._category = parsedRecord.category;
        event._subcategory = parsedRecord.subcategory;
        event._code = parsedRecord.code;
        event._data = parsedRecord.data;
        return event;
    }
}
exports.default = LogEvent;
//# sourceMappingURL=logEvent.js.map